// id of the page's main content region. It is the target of the cookie banner's
// "skip to content" link (SkipToContentLink) and is set by PageContainer.
export const MAIN_CONTENT_ID = 'main-content';
